import ProfileLayout from './ProfileLayout';

export default ProfileLayout;
